<template>
    <div class="animated fadeIn">        
        <b-card>
            <div slot="header">
                Bread Order Form - Kiriman Susulan
                <div class="card-header-actions">
                <button  v-if="saveEnabled" class="btn btn-primary mr-1" @click="save()"><i class="fa fa-save"></i> Save</button>
                  <button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
                </div>
            </div>
            <b-form>
              <b-row>
                <b-col md="6">                            
                    <b-input-group>
                        <b-input-group-append><span class="input-group-text">Order Date</span></b-input-group-append>
                        <b-form-input v-model="model.orderdate" type="date" @change="tanggalBerubah" :state="!$v.model.orderdate.$error"></b-form-input>                                        
                        <b-input-group-prepend><span class="p-2">Order Number</span></b-input-group-prepend>
                        <b-form-input v-model="model.orderno" readonly v-on:click.ctrl="generateQtyCustomer"></b-form-input>
                    </b-input-group>
                </b-col>
                <b-col md="6">
                    <b-input-group >
                        <b-input-group-prepend><label>Customer</label></b-input-group-prepend>
                    <b-form-input
                        readonly
                        @change="customerChange"
                        v-model="model.custinfo"
                        :state="!$v.model.customer_id.$error"
                    ></b-form-input>
                     <b-input-group-append>
                        <b-btn text="Button" @click="lkuCustomerShow=true" >
                            <i class="fa fa-search"></i>
                        </b-btn>
                        </b-input-group-append>
                    </b-input-group>                                        
                </b-col>
              </b-row>
              <b-card no-body class="mb-1">
                <b-table-simple hover small responsive bordered>                    
                    <b-thead head-variant="light">
                        <b-tr>
                            <b-th sticky-column style="min-width:295px;" variant="light">Item</b-th>
                            <b-th  width="50px" v-for="kol in customers" :key="kol.CustCode" class="text-center" style="min-width:100px;">{{kol.CustName}}</b-th>
                            <b-th style="text-align:right;min-width:100px" width="80px" variant="success" >Total Qty</b-th>
                            <b-th style="text-align:right;min-width:100px" width="100px" variant="success">Purc.Price</b-th>
                            <b-th style="text-align:right;min-width:100px" width="100px" variant="success">Amount</b-th>
                        </b-tr>
                    </b-thead>
                    <b-tbody>
                        <b-tr  v-for="(row,idx) in ordLines.items" :key="row.podtlkey">
                            <b-th sticky-column> 
                            <div style="display: inline-block; width:295px">
                                <div style="width:215px;font-weight: normal !important; ">{{idx+1}}. {{row.itemname}} </div>
                                <div style="float:right; margin-top:-20px; width:80px;text-align:right; font-size:smaller; font-weight: normal !important;" v-if="(row.unitprice)"> @{{uanguser}} {{row.unitprice | numFormat}}</div>
                                <div style="float:right; margin-top:-20px; width:80px;text-align:right; background-color:yellow; " v-else></div>
                            </div>
                            </b-th>
                            <b-td v-for="kol in customers" :key="kol.CustCode" style="padding:0 !important;">
                                  <input type="number" style="width:100%; border:none;" :min="0" v-model="row[`K${kol.CustCode}`]" @change="calcTotQty(row)" :key="`${row.podtlkey}${kol.CustCode}`"/>
                            </b-td>
                            <b-td  style="text-align:right" variant="success">
                                {{row.quantity | numFormat}}
                            </b-td>
                            <b-td  style="text-align:right; padding:0 !important;" variant="success">
                                <my-number class="form-control text-right" v-model="row.unitprice" :precision="0" size="sm" @change="calcPriceDelay(row)"></my-number>
                            </b-td>
                            <b-td  style="text-align:right" variant="success">
                                {{row.nilai | numFormat}}
                            </b-td>
                        </b-tr>
                        </b-tbody>
                    </b-table-simple>

              </b-card>    
                <b-row align-h="between" class="mt-1">
                    <b-col lg="8" xl="7">
                        <b-input-group >
                            <b-input-group-prepend><label>Currency </label></b-input-group-prepend>
                            <b-input-group-prepend>
                            <b-form-select  v-model="model.matauang" :plain="true" :options="currency" :state="!$v.model.matauang.$error"></b-form-select>
                            </b-input-group-prepend>
                        </b-input-group>
                        <b-input-group >
                            <b-input-group-prepend><label >Note/Description</label></b-input-group-prepend>
                            <b-form-input v-model="model.remark" placeholder="remark/description"></b-form-input>
                        </b-input-group>

                    </b-col>
                    <b-col lg="4">
                        <div class="text-right">
                            <b-input-group >
                                <b-input-group-prepend><label style="text-align: left; width:158px; padding-left:16px;">subtotal</label></b-input-group-prepend>
                                <b-input-group-prepend>
                                    <span class="input-group-text" style="width:60px;">{{model.matauang}}</span>
                                </b-input-group-prepend>
                                <my-number class="form-control text-right" v-model="model.ttlnetto" :precision="2" disabled></my-number>
                            </b-input-group>
                            <b-input-group >
                                <b-input-group-prepend>
                                <b-form-select style="width:158px;"  v-model="calcVAT" :plain="true" :options="calcuationVAT" ></b-form-select>
                                </b-input-group-prepend>
                                <b-input-group-prepend>
                                    <span class="input-group-text" style="width:60px;">{{model.matauang}}</span>
                                </b-input-group-prepend>
                                <my-number class="form-control text-right" v-model="model.nilaippn" :precision="2" :readonly="(calcVAT===1)"></my-number>
                            </b-input-group>
                            <b-input-group >
                                <b-input-group-prepend><label style="text-align: left;width:158px; padding-left:16px;">Total Amount Due</label></b-input-group-prepend>
                                <b-input-group-prepend>
                                    <span class="input-group-text" style="width:60px;">{{model.matauang}}</span>
                                </b-input-group-prepend>
                                <my-number class="form-control text-right" v-model="model.ttlamtdue" :precision="2" disabled></my-number>
                            </b-input-group>
                        </div>
                    </b-col>
                </b-row>
            </b-form>
            <b-row class="justify-content-center mt-1">
                <div style="width:300px;">
                    <b-input-group >
                        <b-input-group-append>
                            <button  v-if="saveEnabled" class="btn btn-primary mr-1" @click="save()"><i class="fa fa-save"></i> Save</button>
                        </b-input-group-append>
                        <b-input-group-append>
                            <button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
                        </b-input-group-append>
                    </b-input-group>
                </div>
            </b-row>

        </b-card>
     <b-modal
      v-model="lkuCustomerShow"
      size="lg"
      :hide-footer="true"
      title="List of Customer"
      :centered="true"
    >
      <lku-customer @click="onSelectLkuCustomer"></lku-customer>
    </b-modal>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       

    </div>
</template>
<style lang="scss">
.input-group {
  padding-bottom: 2px;
  .input-group-prepend {
    label {
      padding-top: 5px;
      padding-right: 5px;
      width: 130px;
    }
  }
}
.form-group {
  margin-bottom: 2px;
  .input-group {
    padding-bottom: 0;
  }
}
.row-details-form {
  .input-group-prepend {
    label {
      padding-top: 5px;
      padding-right: 5px;
      width: 80px;
    }
  }
  label {
    text-align: right !important;
  }
  legend {
    text-align: right !important;
  }
}
</style>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import toastr from "mini-toastr";
import moment from "moment";
import myNumber from "../../components/my-number";
import lkuCustomer from "../lookup/lkuCustomer";
import procure from "../../apis/bakeryorder";
import { validationMixin } from "vuelidate";
import { required, numeric, decimal } from "vuelidate/lib/validators";
toastr.init();

export default {
  components: { Loading, myNumber, lkuCustomer },
  mixins: [validationMixin],
  validations: {
    model: {
      orderdate: { required },
      customer_id: { required },
      matauang: { required },
    },
  },
  data() {
    return {
      saveEnabled: true,
      isLoading: false,
      inputBerlanjut: 0,
      inputLineBerlanjut: 1,
      lkuCustomerShow: false,
      tahun: (this.$store.state.user.tglaktif || "").substring(0, 4),
      uanguser: this.$store.state.user.matauang,
      currency: [{ value: "IDR", text: "IDR" }],
      calcVAT: 1,
      calcuationVAT: [
        { value: 1, text: "VAT (Auto Calc)" },
        { value: 0, text: "VAT (Manual Calc)" },
      ],
      calcPPh: 1,
      calcuationPPH: [
        { value: 1, text: "Nilai PPH(Otomatis)" },
        { value: 0, text: "Nilai PPH(Manual)" },
      ],
      lookupPPH: [],
      customers: [],
      items: [],
      itemprice: [],
      ordLines: {
        items: [],
      },
      model: {
        jasa: 0,
        orderdate: moment().format("YYYY-MM-DD"),
        vendor_id: "",
        vendor: "",
        requestno: "",
        ExpectRcv: "",
        remark: "",
        postgroup: "",
        typegroup: "OPEX",
        matauang: this.$store.state.user.matauang,
        compcode: this.$store.state.user.compcode,
        invterm: "COD",
        kodecash: "",
        terms: [],
        locationdeliv: this.$store.state.user.compaddr,
        ttlnetto: 0,
        nilaippn: 0,
        ttlamtdue: 0,customer_id:'',customerids:[]
      },
      tabIndex: 0,
    };
  },
  computed: {
    invalidModel() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
  },
  created: async function () {
    if (this.$route.params.pohdrkey) {
      toastr.info("Loading Order Detail, please wait");
      try {
        this.isLoading = true;
        const [a, b, data] = await Promise.all([
          procure.customeraktif(),
          procure.itemaktif(),
          procure.detail(this.$route.params),
        ]);
        this.customers = a;
        this.items = b;
        const row = data[0][0];
        row.orderdate = row.orderdate
          ? moment(row.orderdate).format("YYYY-MM-DD")
          : "";
        row.expectreceipt = row.expectreceipt
          ? moment(row.expectreceipt).format("YYYY-MM-DD")
          : "";
        for (var key in row) {
          this.model[key] = row[key];
        }
        if (row.orderdate < this.$store.state.user.tglaktif) {
          this.saveEnabled = false;
        }
        this.ordLines.items = data[1];
        this.ordLines.total = this.ordLines.items.length;
        // this.items.forEach((item)=> {
        //     const idx = this.ordLines.items.findIndex(d => d.itemno==item.itemno)
        //     if (idx==-1){
        //         this.ordLines.items.push({itemno:item.itemno, partnumber:item.partnumber, itemname:item.itemname,
        //         unitprice: item.unitcost, saleprice: item.unitprice });
        //     }
        // });
        this.ordCustomer = data[2];
        this.ordLines.items.forEach((item) => {
          const custLines = this.ordCustomer.filter(
            (ip) => ip.podtlkey == item.podtlkey
          );
          if (custLines) {
            custLines.forEach((kol) => {
              item[`K${kol.CustCode}`] = kol.qtyOrder;
            });
          }
        });

        procure
          .supplierprice({ vendor_id: this.model.vendor_id })
          .then((result) => {
            this.itemprice = result;
          })
          .catch((err) => {
            console.log("item supplierprice -> ", err);
          });

        this.calcTotalDtlOrder();
        this.tanggalBerubah();
        toastr.clear;
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        console.log("error : ", error);
        toastr.error(JSON.stringify(error), "ERROR MESSAGE");
      }
    } else {
      this.isLoading = true;
      this.model.orderdate = moment().format("YYYY-MM-DD");
      const [b] = await Promise.all([
        // procure.customeraktif(),
        procure.itemaktif(),
      ]);
    //   this.customers = a;
    //   console.log(this.customers)
      this.items = b;
      let obj;
      this.items.forEach((item) => {
        obj = {
          itemno: item.itemno,
          partnumber: item.partnumber,
          itemname: item.itemname,
          unitsize: item.unitsize,
          unitprice: item.unitcost,
          saleprice: item.unitprice,
          quantity: 0,
          ttlnetto: 0,
          nilaippn: 0,
          ttlamtdue: 0,
          disc: 0,
        };
        this.ordLines.items.push(obj);
      });
      // this.ordLines.items=b;
      this.ordLines.total = b.length;
      this.isLoading = false;
    }
  },
  methods: {
      customerChange(){},
    onFiltered(filteredItems) {
      this.ordLines.total = filteredItems.length;
    },
    save: async function () {
      if (!this.saveEnabled) {
        toastr.error("View mode cannot be Saved");
        return;
      }
      this.saveEnabled = false;
      if (this.invalidModel) {
        console.log("validation : ", this.$v.model);
        console.log("model obj : ", this.model);
        toastr.error("Please fill the form correctly.", "ERROR MESSAGE");
        this.saveEnabled = true;
      } else {
        try {
          this.isLoading = true;
          this.model.TableName = "po_header";

          // this.model.DimTableKey = diisi dari PR/SR;
          this.model.pohdrkey = this.model.pohdrkey || "";
          this.model.orderno = this.model.orderno || "";
          const row = {};
          for (var key in this.model) {
            row[key] = this.model[key];
          }
          row.terms = this.model.terms;
          row.orderdate = moment(row.orderdate).format("YYYY-MM-DD");
          row.expectreceipt = row.expectreceipt
            ? moment(row.expectreceipt).format("YYYY-MM-DD")
            : undefined;
          let lineno = 1;
          row.lines = this.ordLines.items.reduce((newArr, item) => {
            if ((item.itemno || "") != "") {
              item.lineno = lineno;
              newArr.push(item);
              lineno += 1;
            }
            return newArr;
          }, []);
          if (row.lines.length > 0) {
            const hasil = await procure.saveordercontinue(row);
            this.isLoading = false;
            toastr.success(
              `Success, Trx.Number ${hasil.orderno}`,
              "Save Purchase Order",
              10000
            );
            if (this.inputBerlanjut == 0) {
              this.close();
            } else {
              this.saveEnabled = true;
              const tanggal = this.model.orderdate;
              this.model.ttlamtdue = 0;
              this.model.ttlnetto = 0;
              this.model.nilaippn = 0;
              const keys = ["ttlamtdue", "ttlnetto", "nilaippn"];
              for (var key in this.model) {
                if (keys.indexOf(key) == -1) {
                  this.model[key] = "";
                }
              }
              this.model.orderdate = tanggal;
              this.ordLines.items = [];
              this.ordLines.total = this.ordLines.items.length;
              this.calcTotalDtlOrder();
              this.$v.model.$reset();
            }
          } else {
            toastr.error(
              "Please fill at least 1(one) Order Detail",
              "ERROR MESSAGE"
            );
            this.saveEnabled = true;
            this.isLoading = false;
          }
        } catch (error) {
          this.isLoading = false;
          console.log("error : ", error);
          if (error.sql) {
            toastr.error(error.sql, "ERROR MESSAGE", 10000);
          } else if (error.sqlMessage) {
            toastr.error(error.sqlMessage, "ERROR MESSAGE", 10000);
          } else if (error.message) {
            toastr.error(error.message, "ERROR MESSAGE", 10000);
          } else {
            toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
          }
          this.saveEnabled = true;
        }
      }
    },
    onSelectLkuCustomer: async function (_selected) {   
      try {
            console.log('_selected',_selected)
            this.isLoading = true;
            this.model.custinfo =
            _selected.CustCode.trim() + " | " + _selected.CustName.trim();
            this.model.CustCode = _selected.CustCode;
            this.model.CustName = _selected.CustName;
            this.model.customer_id = _selected.customer_id;
            let findCust = this.customers.find(x=>x.customer_id==_selected.customer_id)
            if(!findCust){
                this.customers.push(_selected);
                this.model.customerids.push(_selected.customer_id);
            }
            this.lkuCustomerShow=false;
            this.isLoading = false;
        }catch(err){
            this.isLoading = false;
            console.log("item supplierprice -> ", err);
        };
    },
    generateQtyCustomer: function () {
      toastr.info("generate Customer Qty Order randomly");
      let obj;
      let orderprice;
      this.ordLines.items.forEach((item) => {
        orderprice = this.itemprice.find((ip) => (ip.itemno = item.itemno));
        if (orderprice) {
          item.unitprice = orderprice.unitprice;
        }
        this.customers.forEach((kol) => {
          item[`K${kol.CustCode}`] = Math.floor(Math.random() * 11);
          item.quantity += item[`K${kol.CustCode}`];
        });

        this.calcPrice(item);
      });
      this.calcTotalDtlOrder();
    },
    calcTotQty: function (record) {
      setTimeout(() => {
        record.quantity = 0;
        this.customers.forEach((kol) => {
          record.quantity += parseFloat(record[`K${kol.CustCode}`] || 0);
        });
        this.calcPrice(record);
        this.calcTotalDtlOrder();
      }, 100);
    },
    calcTotalDtlOrder: function () {
      this.calcVAT = this.calcVAT || 1;
      let nilaippn = 0;
      let ttlnetto = 0;
      let ttlamtdue = 0;
      // let totalpph = 0;
      this.ordLines.items.forEach(function (trx) {
        if (trx.itemno) {
          ttlnetto += trx.nilai || 0;
          nilaippn += trx.nilaippn || 0;
          ttlamtdue = ttlnetto + (nilaippn || 0);
          // totalpph += parseFloat(trx.nilaipph || 0);
        }
      });
      this.model.ttlnetto = ttlnetto;
      if (this.calcVAT == 1) {
        this.model.nilaippn = nilaippn;
      }
      this.model.ttlamtdue = ttlamtdue;
      // this.model.totalpph = totalpph;
    },
    calcAmountDue: function () {
      this.model.ttlamtdue =
        parseFloat(this.model.ttlnetto || 0) +
        parseFloat(this.model.nilaippn || 0);
    },
    calcTaxes: function (record) {
      record.nilainett =
        parseFloat(record.nilai) - parseFloat(record.nilaidisc || 0);
      record.dpp =
        (parseFloat(record.nilai) * parseFloat(record.dppnlain)) / 100;
      if (record.kenappn == 1) {
        record.ppn = record.ppn || 11;
      } else {
        // if ((record.ppn || 0) == 0 ) {
        // record.kenappn = 0;
        record.dpp = 0;
        record.ppn = 0;
      }
      // if (this.model.grossup == 1)
      //     record.dpp = record.dpp * (100 / (100 - record.pph));

      record.nilaippn = (parseFloat(record.ppn) / 100) * record.dpp;
      record.nilaidue = record.nilainett + record.nilaippn;
    },

    calcPrice: function (record) {
      // setTimeout(() => {
      record.nilai = parseFloat(record.quantity) * parseFloat(record.unitprice);
      record.disc = record.disc ? record.disc : 0;
      if (record.disc > 0) {
        record.nilaidisc = (record.disc * record.nilai) / 100.0;
      }
      // }, 100);
      // this.ordLinesObj.nilainett = this.ordLinesObj.nilai - parseFloat(this.model.nilaidisc || 0);
      this.calcTaxes(record);
    },
    calcPriceDelay: function (record) {
      const this_ = this;
      setTimeout(() => {
        record.nilai =
          parseFloat(record.quantity) * parseFloat(record.unitprice);
        if (record.disc > 0) {
          record.nilaidisc = (record.disc * record.nilai) / 100.0;
        }
        this_.calcTotalDtlOrder();
      }, 100);
    },
    tanggalBerubah: function () {
      this.tahun = moment(this.model.tanggal).format("YYYY");
    },

    close() {
      //   console.log('this.$store.state.prevRoute.name : ',this.$store.state.prevRoute.name);
      if (
        this.$store.state.prevRoute.name &&
        this.$store.state.prevRoute.name !== "bakery.orderfrm"
      ) {
        router.push({ name: this.$store.state.prevRoute.name });
      } else {
        // router.push({name:'payable.apinv'});
        router.push("home");
      }
    },
  },
};
</script>
